import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Tooltip } from "uiv";
import { computed } from "vue";
import { UserProfileApiModel } from "../../api-models";
import leaderTypeColours from "../../services/utilities/leadertype-colours";

type AvatarVariant = "default" | "faded";

type Props = {
  user: UserProfileApiModel;
  size?: string;
  variant?: AvatarVariant;
  tooltipText?: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'user-avatar',
  props: {
    user: {},
    size: { default: "40px" },
    variant: { default: "default" },
    tooltipText: { default: "" }
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "48c3b56e": (_ctx.size),
  "33c5a6a2": (linearGradient.value)
}))

const props = __props;

const userInitials = computed(() =>
  `${props.user.firstName[0]}${props.user.lastName[0]}`.toUpperCase(),
);

const tooltipText = computed(() => {
  if (props.tooltipText !== "") return props.tooltipText;
  return `${props.user.firstName} ${props.user.lastName}`;
});

const linearGradient = computed((): string => {
  if (!props.user.bestFitLeaderTypes || props.user.bestFitLeaderTypes.length < 2) return "#404040";

  const primaryColour = leaderTypeColours[props.user.bestFitLeaderTypes[0]];
  const secondaryColour = leaderTypeColours[props.user.bestFitLeaderTypes[1]];
  return `linear-gradient(135deg, ${primaryColour}, ${primaryColour} 50%, ${secondaryColour} 50%)`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["avatar-circle", { faded: _ctx.variant === 'faded' }]),
    "data-test": "user-avatar"
  }, [
    _createVNode(_unref(Tooltip), {
      tag: "div",
      text: tooltipText.value,
      style: {"display":"inline-block"},
      placement: "bottom"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", null, _toDisplayString(userInitials.value), 1)
      ]),
      _: 1
    }, 8, ["text"])
  ], 2))
}
}

})